import { render, staticRenderFns } from "./IviewBreadcrumbItem.vue?vue&type=template&id=1026e556&scoped=true&"
import script from "./IviewBreadcrumbItem.vue?vue&type=script&lang=js&"
export * from "./IviewBreadcrumbItem.vue?vue&type=script&lang=js&"
import style0 from "./IviewBreadcrumbItem.vue?vue&type=style&index=0&id=1026e556&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1026e556",
  null
  
)

export default component.exports